<template>
  <div class="chat-container">
    <div class="chat-box-container">
      <div class="chat-header">
        <div class="chat-header-options">
          <div class="chat-header-option">
            <svg
              class="chat-header-icon"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4998 15.5H1.49984C1.27882 15.5 1.06686 15.4122 0.910582 15.2559C0.754301 15.0996 0.666504 14.8877 0.666504 14.6667V8.40583C0.666491 8.28676 0.691996 8.16906 0.741302 8.06068C0.790608 7.95229 0.862568 7.85573 0.952337 7.7775L3.99984 5.12V1.33333C3.99984 1.11232 4.08763 0.900358 4.24392 0.744078C4.4002 0.587797 4.61216 0.5 4.83317 0.5H16.4998C16.7208 0.5 16.9328 0.587797 17.0891 0.744078C17.2454 0.900358 17.3332 1.11232 17.3332 1.33333V14.6667C17.3332 14.8877 17.2454 15.0996 17.0891 15.2559C16.9328 15.4122 16.7208 15.5 16.4998 15.5ZM6.49984 13.8333H8.99984V8.785L5.6665 5.87833L2.33317 8.785V13.8333H4.83317V10.5H6.49984V13.8333ZM10.6665 13.8333H15.6665V2.16667H5.6665V3.93917C5.8615 3.93917 6.05734 4.0075 6.214 4.145L10.3807 7.7775C10.4704 7.85573 10.5424 7.95229 10.5917 8.06068C10.641 8.16906 10.6665 8.28676 10.6665 8.40583V13.8333ZM12.3332 7.16667H13.9998V8.83333H12.3332V7.16667ZM12.3332 10.5H13.9998V12.1667H12.3332V10.5ZM12.3332 3.83333H13.9998V5.5H12.3332V3.83333ZM8.99984 3.83333H10.6665V5.5H8.99984V3.83333Z"
                fill="#131E3B"
              />
            </svg>
            <span class="header-option-name">{{ this.bairro }} </span>
          </div>
          <div class="separador-vertical"></div>
          <div class="chat-header-option">
            <svg
              class="chat-header-icon"
              viewBox="0 0 14 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00017 14.4042L10.536 10.8692C11.2352 10.17 11.7113 9.27904 11.9042 8.30915C12.097 7.33927 11.9979 6.33398 11.6195 5.4204C11.241 4.50682 10.6002 3.72598 9.77793 3.17661C8.9557 2.62724 7.98904 2.33401 7.00017 2.33401C6.0113 2.33401 5.04463 2.62724 4.2224 3.17661C3.40018 3.72598 2.75931 4.50682 2.38085 5.4204C2.00239 6.33398 1.90332 7.33927 2.09618 8.30915C2.28903 9.27904 2.76515 10.17 3.46433 10.8692L7.00017 14.4042ZM11.7143 12.0476L7.00017 16.7617L2.286 12.0476C1.35368 11.1152 0.718779 9.92733 0.461572 8.63413C0.204365 7.34094 0.336407 6.00051 0.841002 4.78236C1.3456 3.5642 2.20008 2.52303 3.2964 1.7905C4.39272 1.05798 5.68164 0.666992 7.00017 0.666992C8.31869 0.666992 9.60761 1.05798 10.7039 1.7905C11.8003 2.52303 12.6547 3.5642 13.1593 4.78236C13.6639 6.00051 13.796 7.34094 13.5388 8.63413C13.2816 9.92733 12.6466 11.1152 11.7143 12.0476ZM1.16683 17.3334H12.8335V19.0001H1.16683V17.3334Z"
                fill="#131E3B"
              />
            </svg>
            <span class="header-option-name"> {{ this.az }} </span>
          </div>
          <div class="separador-vertical"></div>
          <div class="chat-header-option">
            <svg
              class="chat-header-icon"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.6665 15.6667V11.5001H7.33317V15.6667H14.8332V9.83341H3.1665V15.6667H5.6665ZM2.33317 8.16675H15.6665V5.66675H10.6665V2.33341H7.33317V5.66675H2.33317V8.16675ZM1.49984 16.5001V9.83341H0.666504V4.83341C0.666504 4.6124 0.754301 4.40044 0.910582 4.24416C1.06686 4.08788 1.27882 4.00008 1.49984 4.00008H5.6665V1.50008C5.6665 1.27907 5.7543 1.06711 5.91058 0.910826C6.06686 0.754545 6.27882 0.666748 6.49984 0.666748H11.4998C11.7209 0.666748 11.9328 0.754545 12.0891 0.910826C12.2454 1.06711 12.3332 1.27907 12.3332 1.50008V4.00008H16.4998C16.7208 4.00008 16.9328 4.08788 17.0891 4.24416C17.2454 4.40044 17.3332 4.6124 17.3332 4.83341V9.83341H16.4998V16.5001C16.4998 16.7211 16.412 16.9331 16.2558 17.0893C16.0995 17.2456 15.8875 17.3334 15.6665 17.3334H2.33317C2.11216 17.3334 1.9002 17.2456 1.74391 17.0893C1.58763 16.9331 1.49984 16.7211 1.49984 16.5001Z"
                fill="#131E3B"
              />
            </svg>
            <span class="header-option-name"> {{ this.zelador }} </span>
          </div>
          <div class="separador-vertical"></div>
          <div class="chat-header-option">
            <svg
              class="chat-header-icon"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99984 8.16675C10.1049 8.16675 11.1647 8.60574 11.9461 9.38714C12.7275 10.1685 13.1665 11.2283 13.1665 12.3334V17.3334H11.4998V12.3334C11.4999 11.6957 11.2562 11.0822 10.8188 10.6182C10.3813 10.1542 9.78308 9.87499 9.1465 9.83758L8.99984 9.83342C8.36216 9.83338 7.74858 10.077 7.28462 10.5145C6.82066 10.952 6.54141 11.5502 6.504 12.1867L6.49984 12.3334V17.3334H4.83317V12.3334C4.83317 11.2283 5.27216 10.1685 6.05356 9.38714C6.83496 8.60574 7.89477 8.16675 8.99984 8.16675ZM3.58317 10.6667C3.81567 10.6667 4.0415 10.6942 4.25817 10.7451C4.11569 11.1693 4.03131 11.6108 4.00734 12.0576L3.99984 12.3334V12.4051C3.90405 12.3708 3.80441 12.3484 3.70317 12.3384L3.58317 12.3334C3.27244 12.3334 2.97284 12.4492 2.74282 12.6581C2.5128 12.867 2.36883 13.1541 2.339 13.4634L2.33317 13.5834V17.3334H0.666504V13.5834C0.666504 12.8099 0.973795 12.068 1.52078 11.521C2.06776 10.974 2.80962 10.6667 3.58317 10.6667ZM14.4165 10.6667C15.1901 10.6667 15.9319 10.974 16.4789 11.521C17.0259 12.068 17.3332 12.8099 17.3332 13.5834V17.3334H15.6665V13.5834C15.6665 13.2727 15.5507 12.9731 15.3418 12.7431C15.1329 12.513 14.8458 12.3691 14.5365 12.3392L14.4165 12.3334C14.2707 12.3334 14.1307 12.3584 13.9998 12.4042V12.3334C13.9998 11.7784 13.9098 11.2451 13.7423 10.7467C13.9582 10.6942 14.184 10.6667 14.4165 10.6667ZM3.58317 5.66675C4.1357 5.66675 4.66561 5.88624 5.05631 6.27694C5.44701 6.66764 5.6665 7.19755 5.6665 7.75008C5.6665 8.30262 5.44701 8.83252 5.05631 9.22322C4.66561 9.61392 4.1357 9.83342 3.58317 9.83342C3.03064 9.83342 2.50073 9.61392 2.11003 9.22322C1.71933 8.83252 1.49984 8.30262 1.49984 7.75008C1.49984 7.19755 1.71933 6.66764 2.11003 6.27694C2.50073 5.88624 3.03064 5.66675 3.58317 5.66675ZM14.4165 5.66675C14.969 5.66675 15.4989 5.88624 15.8896 6.27694C16.2803 6.66764 16.4998 7.19755 16.4998 7.75008C16.4998 8.30262 16.2803 8.83252 15.8896 9.22322C15.4989 9.61392 14.969 9.83342 14.4165 9.83342C13.864 9.83342 13.3341 9.61392 12.9434 9.22322C12.5527 8.83252 12.3332 8.30262 12.3332 7.75008C12.3332 7.19755 12.5527 6.66764 12.9434 6.27694C13.3341 5.88624 13.864 5.66675 14.4165 5.66675ZM3.58317 7.33342C3.47266 7.33342 3.36668 7.37731 3.28854 7.45545C3.2104 7.53359 3.1665 7.63958 3.1665 7.75008C3.1665 7.86059 3.2104 7.96657 3.28854 8.04471C3.36668 8.12285 3.47266 8.16675 3.58317 8.16675C3.69368 8.16675 3.79966 8.12285 3.8778 8.04471C3.95594 7.96657 3.99984 7.86059 3.99984 7.75008C3.99984 7.63958 3.95594 7.53359 3.8778 7.45545C3.79966 7.37731 3.69368 7.33342 3.58317 7.33342ZM14.4165 7.33342C14.306 7.33342 14.2 7.37731 14.1219 7.45545C14.0437 7.53359 13.9998 7.63958 13.9998 7.75008C13.9998 7.86059 14.0437 7.96657 14.1219 8.04471C14.2 8.12285 14.306 8.16675 14.4165 8.16675C14.527 8.16675 14.633 8.12285 14.7111 8.04471C14.7893 7.96657 14.8332 7.86059 14.8332 7.75008C14.8332 7.63958 14.7893 7.53359 14.7111 7.45545C14.633 7.37731 14.527 7.33342 14.4165 7.33342ZM8.99984 0.666748C9.88389 0.666748 10.7317 1.01794 11.3569 1.64306C11.982 2.26818 12.3332 3.11603 12.3332 4.00008C12.3332 4.88414 11.982 5.73198 11.3569 6.3571C10.7317 6.98223 9.88389 7.33342 8.99984 7.33342C8.11578 7.33342 7.26794 6.98223 6.64281 6.3571C6.01769 5.73198 5.6665 4.88414 5.6665 4.00008C5.6665 3.11603 6.01769 2.26818 6.64281 1.64306C7.26794 1.01794 8.11578 0.666748 8.99984 0.666748ZM8.99984 2.33341C8.55781 2.33341 8.13389 2.50901 7.82133 2.82157C7.50877 3.13413 7.33317 3.55805 7.33317 4.00008C7.33317 4.44211 7.50877 4.86603 7.82133 5.17859C8.13389 5.49115 8.55781 5.66675 8.99984 5.66675C9.44186 5.66675 9.86579 5.49115 10.1783 5.17859C10.4909 4.86603 10.6665 4.44211 10.6665 4.00008C10.6665 3.55805 10.4909 3.13413 10.1783 2.82157C9.86579 2.50901 9.44186 2.33341 8.99984 2.33341Z"
                fill="#131E3B"
              />
            </svg>
            <span class="header-option-name">
              {{ this.vizinhos }} {{ $t("vizinhos") }}
            </span>
          </div>
        </div>
        <div @click="pesquisaToggle()" class="chat-search">
          <svg
            class="header-search-button"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#003063" />
            <path
              d="M20.0206 19.0779L22.8759 21.9326L21.9326 22.8759L19.0779 20.0206C18.0157 20.8721 16.6946 21.3352 15.3333 21.3333C12.0213 21.3333 9.33325 18.6453 9.33325 15.3333C9.33325 12.0213 12.0213 9.33325 15.3333 9.33325C18.6453 9.33325 21.3333 12.0213 21.3333 15.3333C21.3352 16.6946 20.8721 18.0157 20.0206 19.0779ZM18.6833 18.5833C19.5293 17.7132 20.0018 16.5469 19.9999 15.3333C19.9999 12.7546 17.9113 10.6666 15.3333 10.6666C12.7546 10.6666 10.6666 12.7546 10.6666 15.3333C10.6666 17.9113 12.7546 19.9999 15.3333 19.9999C16.5469 20.0018 17.7132 19.5293 18.5833 18.6833L18.6833 18.5833Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div class="message-field">
        <div v-if="messages.length > 0" class="chat-message" id="chat-message">
          <div
            v-for="message of messages"
            :key="message.zeladoria_chat_id + Math.random()"
            class="chat-info"
          >
            <div class="box-1">
              <div v-if="!listaModeracao">
                <svg
                  v-if="!message.usuario_foto"
                  class="chat-avatar"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="20" fill="#003063" />
                  <path
                    d="M18.5522 15.3333L17.2188 16.6667H14.6668V24.6667H25.3335V16.6667H22.7815L21.4482 15.3333H18.5522ZM18.0002 14H22.0002L23.3335 15.3333H26.0002C26.177 15.3333 26.3465 15.4036 26.4716 15.5286C26.5966 15.6536 26.6668 15.8232 26.6668 16V25.3333C26.6668 25.5101 26.5966 25.6797 26.4716 25.8047C26.3465 25.9298 26.177 26 26.0002 26H14.0002C13.8234 26 13.6538 25.9298 13.5288 25.8047C13.4037 25.6797 13.3335 25.5101 13.3335 25.3333V16C13.3335 15.8232 13.4037 15.6536 13.5288 15.5286C13.6538 15.4036 13.8234 15.3333 14.0002 15.3333H16.6668L18.0002 14ZM20.0002 24C19.0277 24 18.0951 23.6137 17.4074 22.9261C16.7198 22.2384 16.3335 21.3058 16.3335 20.3333C16.3335 19.3609 16.7198 18.4282 17.4074 17.7406C18.0951 17.053 19.0277 16.6667 20.0002 16.6667C20.9726 16.6667 21.9053 17.053 22.5929 17.7406C23.2805 18.4282 23.6668 19.3609 23.6668 20.3333C23.6668 21.3058 23.2805 22.2384 22.5929 22.9261C21.9053 23.6137 20.9726 24 20.0002 24ZM20.0002 22.6667C20.619 22.6667 21.2125 22.4208 21.6501 21.9832C22.0877 21.5457 22.3335 20.9522 22.3335 20.3333C22.3335 19.7145 22.0877 19.121 21.6501 18.6834C21.2125 18.2458 20.619 18 20.0002 18C19.3813 18 18.7878 18.2458 18.3502 18.6834C17.9127 19.121 17.6668 19.7145 17.6668 20.3333C17.6668 20.9522 17.9127 21.5457 18.3502 21.9832C18.7878 22.4208 19.3813 22.6667 20.0002 22.6667Z"
                    fill="white"
                  />
                </svg>
                <img v-else class="chat-avatar" :src="message.usuario_foto" />
              </div>
              <div v-if="listaModeracao">
                <input
                  @change="checkCounter"
                  v-model="message.check"
                  type="checkbox"
                />
              </div>
            </div>
            <div class="box-2">
              <div class="chat-name">
                <span class="title">{{ message.usuario_nome }}</span>
                <span class="time">
                  {{ formatDate(message.zeladoria_chat_data) }}</span
                >
              </div>
              <div class="chat-message-line">
                <span class="chat-message-box">{{
                  message.zeladoria_chat_mensagem
                }}</span>
                <svg
                  v-if="!listaModeracao && message.zeladoria_chat_moderado === 0"
                  @click="moderarMensagem(message)"
                  class="icone-moderar"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.9016 15.0809C13.436 16.0105 11.7356 16.5028 9.99996 16.5001C5.50663 16.5001 1.7683 13.2667 0.984131 9.00006C1.34249 7.05899 2.31882 5.2858 3.76746 3.94506L1.15996 1.34006L2.33913 0.160889L18.8383 16.6609L17.6591 17.8392L14.9008 15.0809H14.9016ZM4.9458 5.12505C3.8133 6.15471 3.02439 7.50737 2.6858 9.00006C2.94604 10.1388 3.46852 11.201 4.21163 12.1022C4.95475 13.0034 5.89799 13.7187 6.96626 14.1911C8.03453 14.6636 9.19834 14.8801 10.365 14.8235C11.5317 14.7669 12.6691 14.4387 13.6866 13.8651L11.9966 12.1751C11.2772 12.6282 10.4251 12.8235 9.58016 12.7288C8.73519 12.634 7.9475 12.255 7.34627 11.6537C6.74505 11.0525 6.36599 10.2648 6.27127 9.41986C6.17654 8.57489 6.37178 7.72281 6.82496 7.00339L4.9458 5.12505ZM10.7616 10.9401L8.05996 8.23839C7.91169 8.61584 7.87679 9.02835 7.95955 9.42534C8.04232 9.82233 8.23915 10.1865 8.5259 10.4733C8.81265 10.76 9.17685 10.9569 9.57384 11.0396C9.97084 11.1224 10.3834 11.0875 10.7608 10.9392L10.7616 10.9401ZM17.3391 12.8267L16.1466 11.6351C16.7037 10.8411 17.1003 9.94604 17.3141 9.00006C17.0877 8.00816 16.6619 7.07268 16.0626 6.25047C15.4633 5.42826 14.7031 4.73649 13.8282 4.21723C12.9533 3.69796 11.9819 3.36203 10.9731 3.22986C9.96428 3.09769 8.93914 3.17204 7.95996 3.44839L6.64496 2.13339C7.68413 1.72506 8.81663 1.50006 9.99996 1.50006C14.4933 1.50006 18.2316 4.73339 19.0158 9.00006C18.7605 10.3881 18.1865 11.698 17.3391 12.8267ZM9.76913 5.25672C10.2996 5.22394 10.8309 5.30428 11.3279 5.4924C11.8249 5.68053 12.2763 5.97215 12.6521 6.34793C13.0279 6.72371 13.3195 7.17508 13.5076 7.6721C13.6957 8.16913 13.7761 8.70046 13.7433 9.23089L9.7683 5.25672H9.76913Z"
                    fill="#565E73"
                  />
                </svg>
                <svg
                  v-if="!listaModeracao && message.zeladoria_chat_moderado === 1"
                  @click="reexibirMensagemModal(message)"
                  class="icone-moderar"
                  viewBox="0 0 17 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.6665 5.83325V9.16658L0.666504 4.99992L5.6665 0.833252V4.16659H9.83317C11.6013 4.16659 13.297 4.86896 14.5472 6.11921C15.7975 7.36945 16.4998 9.06514 16.4998 10.8333C16.4998 12.6014 15.7975 14.2971 14.5472 15.5473C13.297 16.7975 11.6013 17.4999 9.83317 17.4999H2.33317V15.8333H9.83317C11.1593 15.8333 12.431 15.3065 13.3687 14.3688C14.3064 13.4311 14.8332 12.1593 14.8332 10.8333C14.8332 9.50717 14.3064 8.2354 13.3687 7.29772C12.431 6.36004 11.1593 5.83325 9.83317 5.83325H5.6665Z"
                    fill="#838998"
                  />
                </svg>
              </div>
              <div
                v-if="message.zeladoria_chat_moderado === 1"
                class="block-alert-message"
              >
                <svg
                  class="alert-icon"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.72183 0.499882L17.6602 14.2499C17.7333 14.3766 17.7718 14.5203 17.7718 14.6665C17.7718 14.8128 17.7333 14.9565 17.6602 15.0832C17.587 15.2099 17.4818 15.3151 17.3552 15.3882C17.2285 15.4614 17.0848 15.4999 16.9385 15.4999H1.06183C0.915549 15.4999 0.771848 15.4614 0.645169 15.3882C0.518489 15.3151 0.413294 15.2099 0.340156 15.0832C0.267018 14.9565 0.228515 14.8128 0.228516 14.6665C0.228517 14.5203 0.267022 14.3766 0.340161 14.2499L8.27849 0.499882C8.35164 0.373209 8.45683 0.26802 8.58351 0.194887C8.71019 0.121753 8.85389 0.083252 9.00016 0.083252C9.14643 0.083252 9.29013 0.121753 9.41681 0.194887C9.54349 0.26802 9.64869 0.373209 9.72183 0.499882ZM2.50516 13.8332H15.4952L9.00016 2.58322L2.50516 13.8332ZM8.16683 11.3332H9.83349V12.9999H8.16683V11.3332ZM8.16683 5.49988H9.83349V9.66655H8.16683V5.49988Z"
                    fill="#565E73"
                  />
                </svg>
                <span class="alert-message">{{ $t("mensagemModerada") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-footer">
        <span v-if="!listaModeracao" class="block-alert">{{
          $t("naoPodeMandaMensagem")
        }}</span>
        <div v-if="listaModeracao" class="footer-moderacao">
          <div class="footer-line">
            <svg
              @click="clearListaModeracao"
              class="x-icon"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z"
                fill="#131E3B"
              />
            </svg>
            <span> {{ checks }} {{ $t("mensagensSelecionadas") }} </span>
          </div>

          <div @click="moderarModal()" class="botao-ocultar">
            <span>Ocultar</span>
            <svg
              class="icone"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9019 15.0809C13.4362 16.0105 11.7358 16.5028 10.0002 16.5001C5.50688 16.5001 1.76854 13.2667 0.984375 9.00006C1.34273 7.05899 2.31907 5.2858 3.76771 3.94506L1.16021 1.34006L2.33938 0.160889L18.8385 16.6609L17.6594 17.8392L14.901 15.0809H14.9019ZM4.94604 5.12505C3.81355 6.15471 3.02464 7.50737 2.68604 9.00006C2.94629 10.1388 3.46876 11.201 4.21188 12.1022C4.95499 13.0034 5.89823 13.7187 6.9665 14.1911C8.03477 14.6636 9.19858 14.8801 10.3653 14.8235C11.532 14.7669 12.6694 14.4387 13.6869 13.8651L11.9969 12.1751C11.2775 12.6282 10.4254 12.8235 9.58041 12.7288C8.73544 12.634 7.94774 12.255 7.34652 11.6537C6.74529 11.0525 6.36623 10.2648 6.27151 9.41986C6.17679 8.57489 6.37203 7.72281 6.82521 7.00339L4.94604 5.12505ZM10.7619 10.9401L8.06021 8.23839C7.91193 8.61584 7.87703 9.02835 7.9598 9.42534C8.04256 9.82233 8.23939 10.1865 8.52614 10.4733C8.81289 10.76 9.1771 10.9569 9.57409 11.0396C9.97108 11.1224 10.3836 11.0875 10.761 10.9392L10.7619 10.9401ZM17.3394 12.8267L16.1469 11.6351C16.7039 10.8411 17.1005 9.94604 17.3144 9.00006C17.0879 8.00816 16.6621 7.07268 16.0628 6.25047C15.4636 5.42826 14.7034 4.73649 13.8284 4.21723C12.9535 3.69796 11.9821 3.36203 10.9733 3.22986C9.96452 3.09769 8.93938 3.17204 7.96021 3.44839L6.64521 2.13339C7.68438 1.72506 8.81688 1.50006 10.0002 1.50006C14.4935 1.50006 18.2319 4.73339 19.016 9.00006C18.7607 10.3881 18.1868 11.698 17.3394 12.8267ZM9.76937 5.25672C10.2998 5.22394 10.8311 5.30428 11.3282 5.4924C11.8252 5.68053 12.2766 5.97215 12.6523 6.34793C13.0281 6.72371 13.3197 7.17508 13.5079 7.6721C13.696 8.16913 13.7763 8.70046 13.7435 9.23089L9.76854 5.25672H9.76937Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div v-if="sidebarPesquisa" class="sidebar-pesquisa">
      <div class="pesquisar-title">
        <span>{{ $t("pesquisarMensagens") }}</span>
        <svg
          @click="pesquisaToggle()"
          class="x-icon"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z"
            fill="#131E3B"
          />
        </svg>
      </div>
      <div class="sidebar-pesquisa-input">
        <Input
          class="input-buscar"
          v-model="palavraChaveChat"
          @keyup.enter.native="filtrarPalavraChave"
        />
      </div>
      <div v-if="palavraChaveList.length === 0" class="nada-pesquisado">
        <span> {{ $t("pesquisarPorMensagensEm") }} {{ this.az }} </span>
        <svg
          class="icone-lupa"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.0413 20.1561L27.752 25.8654L25.8653 27.7521L20.156 22.0414C18.0316 23.7444 15.3893 24.6706 12.6666 24.6667C6.04263 24.6667 0.666626 19.2907 0.666626 12.6667C0.666626 6.04275 6.04263 0.666748 12.6666 0.666748C19.2906 0.666748 24.6666 6.04275 24.6666 12.6667C24.6705 15.3894 23.7443 18.0317 22.0413 20.1561ZM19.3666 19.1667C21.0588 17.4266 22.0038 15.094 22 12.6667C22 7.50941 17.8226 3.33341 12.6666 3.33341C7.50929 3.33341 3.33329 7.50941 3.33329 12.6667C3.33329 17.8227 7.50929 22.0001 12.6666 22.0001C15.0939 22.0039 17.4265 21.0589 19.1666 19.3667L19.3666 19.1667Z"
            fill="#DDDEE3"
          />
        </svg>
      </div>
      <div v-else class="search-sidebar-box">
        <div
          v-for="palavra of palavraChaveList"
          :key="palavra.usuario_foto"
          class="resultado-palavra-chave"
          @click="focarMensagem(palavra)"
          :id="palavra.zeladoria_chat_data"
        >
          <div class="data-palavra-chave">
            {{ formatDate(palavra.zeladoria_chat_data) }}
          </div>
          <div class="mensagem-palavra-chave">
            {{ palavra.usuario_nome }}:
            {{
              palavra.zeladoria_chat_mensagem.length > 30
                ? palavra.zeladoria_chat_mensagem.substring(0, 30) + "..."
                : palavra.zeladoria_chat_mensagem
            }}
          </div>
        </div>
      </div>
    </div>

    <Modal v-show="modalModerar" :width="500" :height="280">
      <template v-slot:header>
        <div class="header-modal">
          <span class="page-nav title">{{ $t("confirmacaoDeModeracao") }}</span>
          <svg
            @click="moderarModal()"
            class="x-icon"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z"
              fill="#131E3B"
            />
          </svg>
        </div>
      </template>
      <template v-slot:body>
        <div class="body-modal">
          <span class="text">{{ $t("desejaOcultar") }}</span>
        </div>
      </template>
      <template v-slot:footer>
        <div class="botoes-modal">
          <button class="botao-confirmar" @click="ocultarMensagens">
            {{ $t("confirm") }}
          </button>
          <button class="botao-cancelar" @click="moderarModal()">
            {{ $t("cancel") }}
          </button>
        </div>
      </template>
    </Modal>

    <Modal v-show="modalReexibir" :width="500" :height="320">
      <template v-slot:header>
        <div class="header-modal">
          <span class="page-nav title">{{ $t("desfazerModeracao") }}</span>
          <svg
            @click="reexibirMensagemModal()"
            class="x-icon"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z"
              fill="#131E3B"
            />
          </svg>
        </div>
      </template>
      <template v-slot:body>
        <div class="body-modal">
          <span class="text">{{ $t("desfazerModeracaoAlert") }}</span>
        </div>
      </template>
      <template v-slot:footer>
        <div class="botoes-modal">
          <button class="botao-confirmar" @click="removerModeracao">
            {{ $t("confirm") }}
          </button>
          <button class="botao-cancelar" @click="reexibirMensagemModal()">
            {{ $t("cancel") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Input from "../../components/form/Input.vue";
import moment from "moment";
import services from "../../services";
//import Loading from "../../components/IndexComponents/Loading.vue";
import Modal from "../../components/Modal.vue";
import { debounce } from "../../utils/debounce";

export default {
  components: {
    Input,
    Modal,
    //Loading,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    vizinhos: {
      type: Number,
      default: 0,
    },
    bairro: {
      type: String,
      default: "-",
    },
    zelador: {
      type: String,
      default: "-",
    },
    az: {
      type: String,
      default: "-",
    },
  },
  mounted: async function () {
    this.loadingData = true;

    this.loadingData = false;
  },
  data() {
    return {
      loadingData: false,
      sidebarPesquisa: false,
      palavraChaveChat: null,
      listaModeracao: false,
      moderarPayload: [],
      checks: 1,
      modalModerar: false,
      modalReexibir: false,
      reexibir: null,
      palavraChaveList: [],
    };
  },

  watch: {
    palavraChaveChat: debounce(async function (newVal) {
      console.log(newVal);
      this.filtrarPalavraChave();
    }, 500),
  },

  methods: {
    pesquisaToggle() {
      this.sidebarPesquisa = !this.sidebarPesquisa;
    },

    formatDate(date) {
      if (date) {
        let dia = moment(date).utc().format("DD/MM/YYYY");
        let hora = moment(date).utc().format("LT");
        const result = dia + " - " + hora;
        return result;
      }
      return "-";
    },

    moderarMensagem(mensagem) {
      this.listaModeracao = true;
      this.messages.find(
        (item) => item.zeladoria_chat_id === mensagem.zeladoria_chat_id
      ).check = true;
    },

    checkCounter() {
      this.checks = this.messages.filter((item) => item.check === true).length;
    },

    clearListaModeracao() {
      this.listaModeracao = false;
      this.messages.map((item) => {
        item.check = false;
      });
      this.checks = 1;
    },

    async ocultarMensagens() {
      let blockList = [];
      blockList = this.messages
        .filter((item) => item.check === true)
        .map((thing) => {
          return thing.zeladoria_chat_id;
        });
      this.messages
        .filter((item) => item.check === true)
        .map((thing) => {
          thing.zeladoria_chat_moderado = 1;
        });
      const { errors } = await services.chat.moderarMensagem({
        zeladoria_chat_id: blockList,
        zeladoria_chat_moderado_por:
          this.$store.state.global.user.usuario_gestor_nome,
      });
      if (!errors) {
        this.clearListaModeracao();
      }
      this.moderarModal();
    },

    async removerModeracao() {
      const { errors } = await services.chat.removerModeracao({
        zeladoria_chat_id: this.reexibir,
        zeladoria_chat_moderado_por:
          this.$store.state.global.user.usuario_gestor_nome,
      });
      if (!errors) {
        this.messages
          .filter((item) => item.zeladoria_chat_id === this.reexibir)
          .map((thing) => {
            thing.zeladoria_chat_moderado = 0;
          });
      }
      this.reexibirMensagemModal();
    },

    moderarModal() {
      this.modalModerar = !this.modalModerar;
    },

    reexibirMensagemModal(mensagem) {
      this.modalReexibir = !this.modalReexibir;
      this.reexibir = mensagem.zeladoria_chat_id;
    },

    async filtrarPalavraChave() {
      this.palavraChaveList = [];
      if (this.palavraChaveChat) {
        const { data } = await services.chat.filterMessagesByWord({
          filter: this.palavraChaveChat,
          zeladoria_id: this.messages[0].zeladoria_id,
        });
        this.palavraChaveList = data;
      }
    },

    async focarMensagem(palavra) {
      var msg = document.getElementById(palavra.zeladoria_chat_data);
      var box = document.getElementById("chat-message");
      box.scrollTop = msg.offsetTop - 100;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.chat-box-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 24px;
  padding-left: 20px;
}
.chat-header {
  width: 100%;
  height: 80px;
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dddee3;
}
.chat-footer {
  width: 100%;
  height: 84px;
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #dddee3;
  border-left: 1px solid #dddee3;
  margin-left: -1px;
}
.chat-header-options {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.header-option-name {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #131e3b;
  margin-left: 10px;
}
.chat-header-icon {
  width: 18px;
  height: 18px;
}
.separador-vertical {
  border-right: 1px solid #b0b4bd;
  height: 20px;
  margin: 16px;
}
.header-search-button {
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.sidebar-pesquisa {
  min-width: 280px;
  width: 20%;
  min-width: 250px;
  border-left: 1px solid #b0b4bd;
  padding: 24px;
  padding-top: 48px;
}
.pesquisar-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #131e3b;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.x-icon {
  width: 12px;
  height: 12px;
  cursor: pointer;
}
.sidebar-pesquisa-input {
  margin: 24px 0px;
}
.icone-lupa {
  width: 27px;
  height: 27px;
  margin: 18px 0px;
}
.nada-pesquisado {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #565e73;
}
.message-field {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  background: rgba(230, 234, 239, 0.4);
}
.block-alert {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #5f5f5f;
}

.chat-info {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 16px;
  .box-1 {
    display: flex;
  }
  .box-2 {
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 50%;
  }
}
.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.chat-message {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  max-height: 78vh;
  padding: 24px;
  overflow-y: scroll;
}
.chat-message::-webkit-scrollbar-track {
  background-color: rgba(230, 234, 239, 0) !important;
}
.chat-name {
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 132%;
    color: #131e3b;
  }
  .time {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #565e73;
    margin-left: 8px;
  }
}
.chat-message-box {
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  padding: 12px;
  background: rgba(221, 222, 227, 0.48);
  border-radius: 2px 12px 12px 12px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #5f5f5f;
  flex-wrap: wrap;
  width: fit-content;
}
.chat-message-line {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.icone-moderar {
  width: 18px;
  height: 17px;
  margin-left: 12px;
  cursor: pointer;
  opacity: 0;
}
.chat-info:hover{
  .icone-moderar {
    opacity: 1
  }
}
.botao-ocultar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;
  background: #003063;
  border-radius: 6px;
  color: white;
  width: 107px;
  height: 32px;
  cursor: pointer;
  .icone {
    width: 18px;
    height: 17px;
    margin-left: 16px;
  }
}
.footer-moderacao {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .footer-line {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 30px;
    }
  }
}
.botoes-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  .botao-confirmar {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    background-color: #003366;
    color: white;
    padding: 10px 8px;
    border-radius: 8px;
    outline: none;
  }
  .botao-cancelar {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    background-color: white;
    color: #003366;
    padding: 10px 8px;
    border-radius: 8px;
    margin-top: 8px;
    outline: none;
  }
}
.header-modal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;

  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    color: #131e3b;
    margin-left: 45px;
  }
  .x-icon {
    width: 16px;
    height: 16px;
    margin-left: 65px;
  }
}
.body-modal {
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  .text {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 156%;
    color: #838998;
  }
}
.block-alert-message {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px 12px;
  border: 2px solid #dddee3;
  border-radius: 12px;
  margin-top: 6px;
  .alert-icon {
    width: 18px;
    height: 18px;
    margin-right: 12px;
  }
  .alert-message {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #565e73;
  }
}
.resultado-palavra-chave {
  padding: 12px;
  border-bottom: 1px solid #dddee3;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #565e73;
  height: 70px;
  cursor: pointer;
}

.search-sidebar-box {
  max-height: 78vh;
  overflow-y: auto;
}

@media screen and (min-width: 1px) and (max-width: 1083px) {
  .separador-vertical {
    display: none;
  }
  .chat-header-option {
    margin-right: 50px;
  }
}
@media screen and (min-width: 1px) and (max-width: 800px) {
  .chat-header {
    width: 100%;
    height: 130px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dddee3;
  }
  .chat-header-option {
    margin-right: 10px;
  }

  .chat-container {
    display: flex;
    flex-direction: column;
  }
  .sidebar-pesquisa {
    width: 100%;
    min-width: none;
    justify-content: center;
    align-items: center;
    margin-left: 35px;
  }
}
</style>
